import { endpointConstants } from '../constants'

const initialState = {
  loading: false,
  error: null,
  list: null,
  init: false,
  updating: false
}

export default function endpoint(state = initialState, action) {
  switch (action.type) {
    case endpointConstants.ENDPOINT_LOAD:
      return {
        ...state,
        loading: true,
        list: null,
        init: true
      }
    case endpointConstants.ENDPOINT_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.list,
        count: action.payload.count
      }
    case endpointConstants.ENDPOINT_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case endpointConstants.ENDPOINT_SAVE:
    case endpointConstants.ENDPOINT_DELETE:
      return {
        ...state,
        updating: true
      }
    case endpointConstants.ENDPOINT_SAVE_SUCCESS:
      const list = state.list.find((x) => x._id === action.payload._id)
        ? state.list.map((x) => {
            return x._id === action.payload._id ? action.payload : x
          })
        : [...state.list, action.payload]
      return {
        ...state,
        updating: false,
        list,
        count: list.count
      }
    case endpointConstants.ENDPOINT_SAVE_FAILURE:
    case endpointConstants.ENDPOINT_DELETE_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload
      }
    case endpointConstants.ENDPOINT_DELETE_SUCCESS:
      return {
        ...state,
        updating: false,
        list: state.list.filter((x) => x._id !== action.payload),
        count: state.count - 1
      }
    case endpointConstants.ENDPOINT_RESET:
      return {
        ...initialState
      }
    default:
      return state
  }
}
